<template>
  <v-dialog
    persistent
    @keydown.esc="_cancel"
    v-model="openDialog"
    :retain-focus="false"
    width="550"
    style="min-height: 350px"
  >
    <v-card class="d-flex flex-column">
      <v-card-title class="headline white--text app-gradient">
        <h3 class="white--text">Επιβεβαίωση Ενέργειας</h3>
        <v-spacer></v-spacer>
        <v-icon @click="_cancel" color="white">close</v-icon>
      </v-card-title>

      <v-card-text
        style="background-color: #cecece"
        class="justify-center pt-12"
      >
        <v-row>
          <v-col>
            <h3 class="black--text">{{ message }}</h3>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions
        style="background-color: #cecece"
        class="justify-center pb-12 pt-6"
      >
        <v-btn
          @click="_cancel"
          style="text-transform: none !important"
          rounded
          outlined
          color="primary"
        >
          Άκυρο
          <v-icon size="25" color="primary" right dark>
            mdi-close-circle
          </v-icon>
        </v-btn>

        <v-btn
          @click="_confirm"
          style="text-transform: none !important"
          rounded
          outlined
          color="#07575b"
        >
          Επιβεβαίωση
          <v-icon size="25" color="#07575b" right dark>
            mdi-checkbox-marked-circle
          </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CustomWindowConfirm",
  data: () => ({
    openDialog: false,
    title: undefined,
    message: undefined,
    resolvePromise: undefined,
    rejectPromise: undefined,
  }),

  methods: {
    show(opts = {}) {
      this.message = opts.message;
      this.openDialog = true;
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },

    _confirm() {
      this.openDialog = false;
      this.resolvePromise(true);
    },

    _cancel() {
      this.openDialog = false;
      this.resolvePromise(false);
    },
  },
};
</script>

<style scoped></style>
